/** Invite artwork retained for the never-entered OA sequence. */
export const preEntryInviteCreatives = [
  'viralmessage_22_jp',
  'invite_mystery_crate',
  'viralmessage_21_jp',
  'invite_doghouse_a_jp',
  'viralmessage_12_jp',
] as const;

/** Ordered steps; notification IDs use these names under the preEntry prefix. */
export const preEntrySteps = [
  'd1_morning',
  'd1_evening',
  'd2_morning',
  'd2_lunch',
  'd2_evening',
  'd3_reengagement',
] as const;
